<template>
  <section class="p-toppage__info">
    <div class="p-toppage__info__wrap">
      <template v-if="error">
        <p>{{ error }}</p>
      </template>
      <template v-if="isLoading">
        <LoadingContent />
      </template>
      <template v-else>
        <template v-if="tab_id === 0">
          <CMS
            contents_type="block_contents"
            location_code="IC_MENUTOP_02_01_001_menutitle"
          />
          <CMS
            contents_type="block_contents"
            location_code="IC_MENUTOP_02_01_002_menu"
          />
        </template>
        <template v-else-if="tab_id === 1">
          <CMS
            contents_type="block_contents"
            location_code="IC_MENUTOP_02_02_001_menutitle"
          />
          <CMS
            contents_type="block_contents"
            location_code="IC_MENUTOP_02_02_002_menu"
          />
        </template>
      </template>
    </div>
  </section>
</template>
<script lang="ts">
import { Options, Vue } from "vue-class-component";
import CMS from "@/general/components/CMS.vue";

@Options({
  name: "Z04RecommendMenu",
  props: {
    tab_id: { type: Number, default: 0 }
  },
  components: {
    CMS
  }
})
export default class Z04RecommendMenu extends Vue {
  tab_id!: number;

  error = null;
  isLoading = true;

  async created() {
    this.isLoading = false;
  }
}
</script>
<style lang="scss" scoped>
.c-card {
  box-shadow: none !important;
}
.p-toppage {
  &__info__wrap {
    h2 {
      &.c-title {
        font-size: 1.5rem;
        line-height: 1.5;
        position: relative;
        padding-left: 1rem;
      }
    }
  }
}
</style>
